import { Button } from '@/components/ui/Button'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/Dialog'
import { useOnboarding } from '@/contexts/OnboardingContext'
import './help-dialog.css'

interface HelpDialogProps {
	isOpen: boolean
	onClose: () => void
}

const AVAILABLE_TOURS = [
	{ id: 'content-manager', name: 'Content Manager', description: 'Learn to organize playbooks and content' },
]

export function HelpDialog({ isOpen, onClose }: HelpDialogProps) {
	const { isCompleted, startTour, resetAllTours } = useOnboarding()

	const handleStartTour = (tourId: string) => {
		onClose()
		startTour(tourId)
	}

	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
			<DialogContent className="help-dialog">
				<DialogHeader>
					<DialogTitle>Help & Tours</DialogTitle>
				</DialogHeader>
				<div className="help-dialog__section-title">Guided Tours</div>
				<div className="help-dialog__tour-list">
					{AVAILABLE_TOURS.map((tour) => (
						<div key={tour.id} className="help-dialog__tour-item">
							<div>
								<div className="help-dialog__tour-name">{tour.name}</div>
								<div className="help-dialog__tour-status" data-completed={isCompleted(tour.id)}>
									{isCompleted(tour.id) ? 'Completed' : 'Not started'}
								</div>
							</div>
							<Button variant="outline" size="sm" onClick={() => handleStartTour(tour.id)}>
								{isCompleted(tour.id) ? 'Retake Tour' : 'Take Tour'}
							</Button>
						</div>
					))}
				</div>
				<Button variant="ghost" size="sm" onClick={resetAllTours} className="help-dialog__reset">
					Reset All Tours
				</Button>
			</DialogContent>
		</Dialog>
	)
}
